export class LaborVersions {
    /**
     * @type {Element}
     */
    target = null;

    /**
     * @type {HTMLFormElement|null}
     */
    form = null;

    /**
     * @type {HTMLSelectElement|null}
     */
    productCategorySelect = null;

    /**
     * @type {HTMLSelectElement|null}
     */
    productNameSelect = null;

    /**
     * @type {HTMLSpanElement|null}
     */
    productNameSelect2 = null;

    /**
     * @type {HTMLDivElement|null}
     */
    productList = null;

    /**
     * @type {NodeListOf<HTMLElement>|null}
     */
    products = null;

    /**
     * @type {string[]}
     */
    categories = [];

    /**
     * @type {boolean}
     */
    categorySelectedForTheFirstTime = false;

    /**
     * @param {Element} target
     */
    constructor(target) {
        this.target = target;
        this.form = target.querySelector('form');
        this.productCategorySelect = target.querySelector('.laborversions-category-select');
        this.productNameSelect = target.querySelector('.laborversions-name-select');
        this.productNameSelect2 = this.productNameSelect.parentElement.querySelector('.select2');
        this.productList = target.querySelector('.laborversions-product-list');
        this.products = this.productList.querySelectorAll('.laborversions-product');
        this.categories = Array.from(this.productCategorySelect.options).map(option => option.value);
        this.names = Array.from(this.productNameSelect.options).map(option => option.text);
        this.namesByCategory = JSON.parse(this.productList.dataset.namesByCategory);

        this.hideAllProducts();
        this.setupEventHandler();
    }

    /**
     * Add event handler
     *
     * @protected
     * @return void
     */
    setupEventHandler() {
        $(this.productCategorySelect).on('change', () => {
            this.filterProductsByCategory();
            if (this.productNameSelect.value) {
                this.showElement(this.productNameSelect.parentElement);
            } else {
                this.hideElement(this.productNameSelect.parentElement);
            }
        });

        $(this.productNameSelect).on('change', this.showProduct.bind(this));

        window.addEventListener('load', (event) => {
            $(this.productCategorySelect).trigger('change');
        });
    }

    filterProductsByCategory() {
        const selectedCategory = this.productCategorySelect.value;

        if (!selectedCategory) {
            return;
        }

        const namesForSelectedCategory = this.namesByCategory[selectedCategory];

        this.productNameSelect.innerHTML = '';

        // Create new options for each name and append them to the productNameSelect
        namesForSelectedCategory.forEach(name => {
            const option = new Option(name, name);
            this.productNameSelect.append(option);
        });

        // Remove the first option from the category select after a category is selected for the first time
        if (!this.categorySelectedForTheFirstTime) {
            this.productCategorySelect.remove(0);
            this.categorySelectedForTheFirstTime = true;
        }

        // Update the select2
        $(this.productNameSelect).trigger('change');
    }

    // show only the product that matches the selected name
    showProduct() {
        this.hideAllProducts();

        const selectedProductName = this.productNameSelect.value.trim();

        for (const product of this.products) {
            const productName = product.dataset.name.trim();

            if (productName === selectedProductName) {
                this.showElement(product);
            }
        }
    }

    hideAllProducts() {
        for (const product of this.products) {
            this.hideElement(product);
        }
    }

    /**
     * @param {HTMLElement} element
     */
    hideElement(element) {
        element.classList.add('js-hide');
    }

    /**
     * @param {HTMLElement} element
     */
    showElement(element) {
        element.classList.remove('js-hide');
    }
}
